module.exports = __webpack_public_path__ + "static/img/p-25.96b6ecb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-25.png
// module id = b3yK
// module chunks = 0